import { render, staticRenderFns } from "./ThreedQuickGroupBox.vue?vue&type=template&id=48c81d1c&scoped=true"
import script from "./ThreedQuickGroupBox.vue?vue&type=script&lang=js"
export * from "./ThreedQuickGroupBox.vue?vue&type=script&lang=js"
import style0 from "./ThreedQuickGroupBox.vue?vue&type=style&index=0&id=48c81d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c81d1c",
  null
  
)

export default component.exports